import { render, staticRenderFns } from "./SignupNew.vue?vue&type=template&id=1288ddf4&scoped=true&"
import script from "./SignupNew.vue?vue&type=script&lang=js&"
export * from "./SignupNew.vue?vue&type=script&lang=js&"
import style0 from "./SignupNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SignupNew.vue?vue&type=style&index=1&id=1288ddf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288ddf4",
  null
  
)

export default component.exports